// import { configureStore } from "@reduxjs/toolkit";
// import userReducer from "./slices/authSlice";
// import menuReducer from "./slices/menuSlice";
// import categoryReducer from "./slices/categorySlice";
// import orderReducer from "./slices/orderSlice";
// import cartReducer from "./slices/cartSlice";
// import qrCodeReducer from "./slices/QRCodeSlice";
// import offerReducer from "./slices/offerSlice";
// import publicReducer from "./slices/publicSlice";
// import bannerReducer from "./slices/bannerSlice";
// import staffReducer from "./slices/staffSlice";
// import usersReducer from "./slices/userSlice";
// import paymentsReducer from "./slices/paymentsSlice";
// import ratingReducer from "./slices/ratingSlice";
// import statsReducer from "./slices/statsSlice";
// import supportReducer from "./slices/supportSlice";
// import billingReducer from "./slices/billingSlice";
// import adminReducer from "./slices/adminSlice";
// import adminDashboardReducer from "./slices/adminDashboardSlice";
// import notificationReducer from "./slices/notificationSlice";
// import adminRestaurantReducer from "./slices/adminRestaurantSlice";
// import adminInvoiceReducer from "./slices/adminInvoicesSlice";
// import adminPaymentsReducer from "./slices/adminPaymentsSlice";
// import adminContactReducer from "./slices/adminContactSlice";
// import myOrdersReducer from "./slices/myOrdersSlice";

// export const store = configureStore({
//   reducer: {
//     user: userReducer,
//     menu: menuReducer,
//     category: categoryReducer,
//     order: orderReducer,
//     cart: cartReducer,
//     qrcode: qrCodeReducer,
//     offers: offerReducer,
//     public: publicReducer,
//     banner: bannerReducer,
//     staff: staffReducer,
//     users: usersReducer,
//     payments: paymentsReducer,
//     rating: ratingReducer,
//     stats: statsReducer,
//     support: supportReducer,
//     billing: billingReducer,
//     admin: adminReducer,
//     notification: notificationReducer,
//     adminDashboard: adminDashboardReducer,
//     adminRestaurant: adminRestaurantReducer,
//     adminInvoices: adminInvoiceReducer,
//     adminPayments: adminPaymentsReducer,
//     adminContact: adminContactReducer,
//     myOrders: myOrdersReducer,
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),
// });

import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage

import userReducer from "./slices/authSlice";
import menuReducer from "./slices/menuSlice";
import categoryReducer from "./slices/categorySlice";
import orderReducer from "./slices/orderSlice";
import cartReducer from "./slices/cartSlice";
import qrCodeReducer from "./slices/QRCodeSlice";
import offerReducer from "./slices/offerSlice";
import publicReducer from "./slices/publicSlice";
import bannerReducer from "./slices/bannerSlice";
import staffReducer from "./slices/staffSlice";
import usersReducer from "./slices/userSlice";
import paymentsReducer from "./slices/paymentsSlice";
import ratingReducer from "./slices/ratingSlice";
import statsReducer from "./slices/statsSlice";
import supportReducer from "./slices/supportSlice";
import billingReducer from "./slices/billingSlice";
import adminReducer from "./slices/adminSlice";
import adminDashboardReducer from "./slices/adminDashboardSlice";
import notificationReducer from "./slices/notificationSlice";
import adminRestaurantReducer from "./slices/adminRestaurantSlice";
import adminInvoiceReducer from "./slices/adminInvoicesSlice";
import adminPaymentsReducer from "./slices/adminPaymentsSlice";
import adminContactReducer from "./slices/adminContactSlice";
import myOrdersReducer from "./slices/myOrdersSlice";

// ── Combine all reducers ─────────────────────────────
const rootReducer = combineReducers({
  user: userReducer,
  menu: menuReducer,
  category: categoryReducer,
  order: orderReducer,
  cart: cartReducer, // 🔥 Ye persist hoga
  qrcode: qrCodeReducer,
  offers: offerReducer,
  public: publicReducer,
  banner: bannerReducer,
  staff: staffReducer,
  users: usersReducer,
  payments: paymentsReducer,
  rating: ratingReducer,
  stats: statsReducer,
  support: supportReducer,
  billing: billingReducer,
  admin: adminReducer,
  notification: notificationReducer,
  adminDashboard: adminDashboardReducer,
  adminRestaurant: adminRestaurantReducer,
  adminInvoices: adminInvoiceReducer,
  adminPayments: adminPaymentsReducer,
  adminContact: adminContactReducer,
  myOrders: myOrdersReducer,
});

// ── Persist config ───────────────────────────────────
// 🔥 Sirf cart persist karo — baaki state fresh rakho
const persistConfig = {
  key: "rw_root",
  version: 1,
  storage,
  whitelist: ["cart"], // 👈 Sirf cart persist hoga
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ── Store ────────────────────────────────────────────
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // redux-persist internal actions ignore karo
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// ── Optional: Dev-only helper ────────────────────────
if (process.env.NODE_ENV === "development") {
  window.__store = store;
  window.__persistor = persistor;
}